// extracted by mini-css-extract-plugin
export default {"wrapper":"EnrollInheritance_wrapper__-RL0v","row":"EnrollInheritance_row__huJdl"};